module.exports = __webpack_public_path__ + "img/empty.ff66ad0.png";